import { breakpoints } from '../utils/breakpoints';

const selectors = {
  slider: '.js-news-drag-slider',
  scrollbar: '.js-news-drag-scrollbar',
};

const handleNewsDrag = () => {
  const { innerWidth } = window;
  if (innerWidth >= breakpoints.tablet) return;

  const slider = document.querySelector(selectors.slider);
  const scrollbar = document.querySelector(selectors.scrollbar);

  if (!slider || !scrollbar) return;

  const setTransform = () => {
    const { scrollLeft, scrollWidth } = slider;
    // scrollLeft  = width of elem - width of window + padding (1rem = 32px);
    const scrollValue =
      (scrollLeft / (scrollWidth - innerWidth + 32)) * 100 * 2;

    scrollbar.style.transform = `translateX(${scrollValue}%)`;
  };

  // init scroll position (center slider)
  slider.scrollLeft = slider.scrollWidth / 3.8;
  setTransform();

  slider.addEventListener('scroll', setTransform);
};

export default handleNewsDrag;
